<template>
  <div class="md:max-w-full">
    <div class="h-64 px-0 mx-0 md:w-full">
      <div class="bg-primary h-[204px] p-4 md:p-0" v-if="agentDetails">
        <div class="flex justify-between h-full max-w-6xl pt-5 mx-auto">
          <div class="flex space-x-5">
            <img
              :src="agentDetails.photo"
              class="rounded-lg w-[250px] h-[250px]"
              alt=""
            />
            <div class="flex flex-col justify-center">
              <p class="text-3xl font-bold text-white">
                {{ agentDetails.name }}
              </p>
              <p class="py-2 text-white">{{ agentDetails.specialization }}</p>
            </div>
          </div>
          <div class="hidden md:sticky md:flex md:flex-col md:top-2 w-96">
            <div class="sticky top-2">
              <div
                class="flex flex-col w-full p-5 bg-white border border-gray-100 shadow-md"
              >
                <h1 class="px-2 text-xl font-semibold">Contact this agent</h1>
                <div
                  class="flex justify-between pt-5 space-x-2"
                  v-show="showContactInfoButtons"
                >
                  <a
                    :href="showPhoneDetails"
                    @click="showPhoneNumber"
                    class="bg-secondary cursor-pointer w-full text-white rounded flex items-center justify-center hover:bg-red-500 h-[48px] font-semibold"
                  >
                    <CallSvg color="white" height="4" width="4" />
                    <span class="pl-1">Call</span>
                  </a>
                  <button
                    @click="sendEmail"
                    class="bg-secondary cursor-pointer w-full text-white rounded flex items-center justify-center hover:bg-red-500 h-[48px] font-semibold"
                  >
                    <EmailSvg color="white" height="4" width="4" />
                    <span class="pl-1">Email</span>
                  </button>
                  <button
                    @click="shareWhatsApp"
                    class="flex cursor-pointer items-center justify-center w-full text-sm font-bold text-white bg-green-500 rounded hover:bg-green-600 h-[48px]"
                  >
                    <WhatsAppSvg color="white" height="5" width="5" />
                    <span class="pl-1"> WhatsApp</span>
                  </button>
                </div>
                <div
                  class="p-4 mt-3 rounded-md bg-stone-50"
                  v-show="showContactDetails"
                >
                  <div class="flex justify-between">
                    <div class="flex items-center w-7/12">
                      <CallSvg color="secondary" height="4" width="4" />
                      <span class="pl-2 text-secondary">{{
                        agentDetails.whatsapp_number
                      }}</span>
                    </div>
                    <div class="flex space-x-2">
                      <div class="w-6/12 p-2 bg-white rounded">
                        <button @click="sendEmail">
                          <EmailSvg color="secondary" height="5" width="5" />
                        </button>
                      </div>
                      <div class="w-6/12 p-2 bg-white rounded">
                        <button @click="shareWhatsApp">
                          <WhatsAppSvg color="secondary" height="5" width="5" />
                        </button>
                      </div>
                    </div>
                  </div>

                  <hr class="my-1" />
                  <div>
                    <p class="">
                      <a href="" class="text-blue-400">{{
                        agentDetails.name
                      }}</a>
                      <span class="pl-1" v-if="agentDetails.languages">
                        speaks {{ agentDetails.languages.split(",")[0] }}</span
                      >
                    </p>
                  </div>
                </div>
                <div class="flex flex-row items-center mt-5">
                  <p class="pl-1">
                    {{ agentDetails.name }}
                  </p>
                </div>
                <hr class="my-5" />
                <div class="flex items-center justify-between">
                  <div>
                    <p class="text-sm truncate">
                      {{ agentDetails.company.name }}
                    </p>
                    <a href="#" class="text-xs underline text-primary"
                      >About Company</a
                    >
                  </div>
                  <img
                    :src="agentDetails.company.photo"
                    class="object-contain w-16"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SignInModal
      :showViewModal="showLoginModal"
      :modalType="modalType"
      @closeViewModal="closeModal"
      @switchModalType="handleSwitchModalType"
    />
  </div>
</template>
<script>
import { ref, watch } from "vue";
import CallSvg from "@/components/svg/CallSvg.vue";
import EmailSvg from "@/components/svg/EmailSvg.vue";
import WhatsAppSvg from "@/components/svg/WhatsAppSvg.vue";
import useAuth from "@/composables/useAuth";
import SignInModal from "@/components/LoginModal.vue";

export default {
  components: {
    CallSvg,
    EmailSvg,
    WhatsAppSvg,
    SignInModal,
  },
  props: {
    agentDetails: Object,
  },
  setup(props) {
    const { state } = useAuth();
    const isAuthenticated = ref(state.isAuthenticated);

    watch(
      () => state.isAuthenticated,
      (newVal) => {
        isAuthenticated.value = newVal;
      }
    );

    const showContactInfoButtons = ref(true);
    const showContactDetails = ref(false);
    const showPhoneDetails = ref(null);
    const showLoginModal = ref(false);
    const modalType = ref("");

    const shareWhatsApp = () => {
      if (isAuthenticated.value == true) {
        const message = `Hi, I found your property with ref: ${props.agentDetails.reference} on Hutloop. Please contact me. Thank you.!`;
        const showWhatsAppDetails = `https://api.whatsapp.com/send?phone=${
          props.agentDetails.whatsapp_number
        }&text=${encodeURIComponent(message)}`;
        window.open(showWhatsAppDetails, "_blank");
      }
    };

    const sendEmail = () => {
      if (isAuthenticated.value == true) {
        const showEmailDetails = `mailto:
          ${props.agentDetails.email}
          ?subject=Hutloop Property  &body=Hi, I found your property with ref: ${props.agentDetails.reference} on Hutloop. Please contact me. Thank you.!`;

        window.open(showEmailDetails);
      } else {
        showLoginModal.value = true;
        modalType.value = "login";
      }
    };

    const showPhoneNumber = () => {
      showContactInfoButtons.value = false;
      if (isAuthenticated.value == true) {
        showContactDetails.value = true;
        showPhoneDetails.value = "tel:" + props.agentDetails.phone;
      } else {
        showLoginModal.value = true;
        modalType.value = "login";
      }
    };
    const handleSwitchModalType = (type) => {
      modalType.value = type;
    };

    const closeModal = () => {
      showLoginModal.value = false;
      modalType.value = "";
    };

    return {
      shareWhatsApp,
      showLoginModal,
      modalType,
      closeModal,
      handleSwitchModalType,
      showContactInfoButtons,
      showContactDetails,
      showPhoneNumber,
      showPhoneDetails,
      sendEmail,
    };
  },
};
</script>
